import { useContext, useState } from "react";
import PaymentContext from "../../../store/PaymentContext";
import { currencyFormatter } from "../../../utils/format";
import { IProductAccessoryPayment } from "../../../@types/IProduct/IProductAccessory";
import { EditOutlined } from "@ant-design/icons";
import { checkHasData, checkIsFullSet } from "../util";

const SellPayment = ({ isShowRent, isShowSell }: { isShowRent: boolean, isShowSell: boolean }) => {

    const { sellCarts, sellCustomer, sellTotal, sellTransportFee, setModalCustomer, isMobile, rentCarts } = useContext(PaymentContext)


    return isShowSell ? (
        <div className={`cart-box rounded px-4 pb-4 ${isShowRent ? 'mt-4' : ''}`} style={{ minHeight: `${isShowRent ? 'auto' : '77vh'}` }}>
            <div className="heading line-bottom text-lg uppercase">
                Hóa đơn mua
            </div>

            <div className="mt-4 grid grid-cols-1 md:grid-cols-5 gap-4">
                <div className="box-info p-4 rounded-lg bg-white grid-cols-1 md:col-span-3">
                    {
                        sellCarts.map((item: any, index) => {
                            //if (!item.checked) return null;
                            let isFull = checkIsFullSet(item)
                            let accessoriesChecked = item.accessories?.filter((acc: IProductAccessoryPayment) => acc.checked);
                            if (item?.is_product === false) {
                                return <>
                                    {item.checked && <div key={index} className="flex justify-between">
                                        <div>{item.name} <sup>x {item.qty}</sup></div>
                                        <div className="text-right">{currencyFormatter.format(item.price)}</div>
                                    </div>}
                                    {
                                        accessoriesChecked.map((acc: IProductAccessoryPayment, accIndex: number) => (
                                            <div key={`${index}_${accIndex}`} className={"flex justify-between ml-4"}>
                                                <div>{acc.name} <sup>x {acc.qty}</sup></div>
                                                {/* <div className="text-right">{currencyFormatter.format(acc.price ?? 0)}</div> */}
                                            </div>
                                        ))
                                    }
                                </>
                            }

                            if ((!item.checked && item.allowed_split && accessoriesChecked?.length > 0) || (item.checked && item.allowed_split && accessoriesChecked?.length === 1)) {
                                return accessoriesChecked?.length > 0 && (
                                    <div key={index}>
                                        <div key={index} className="flex justify-between">
                                            <div>{item.name} </div>
                                            {/* <div className="text-right">{currencyFormatter.format(item.price)}</div> */}
                                        </div>
                                        {
                                            accessoriesChecked.map((acc: IProductAccessoryPayment, accIndex: number) => (
                                                <div key={`${index}_${accIndex}`} className={"flex flex-row justify-between "}>
                                                    <div>{acc.name} <sup>x {acc.qty}</sup></div>
                                                    <div className="text-right">{currencyFormatter.format(acc.price ?? 0)}</div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                )
                            }

                            if (item.accessories?.length && !isFull) {
                                //console.log("2 mua", item);
                                return accessoriesChecked?.length > 0 && (
                                    <div key={index}>
                                        <div className="flex flex-row justify-between">
                                            <div>{item.name}</div>
                                            <div className="text-right">{currencyFormatter.format(item.price)}</div>
                                        </div>
                                        {
                                            accessoriesChecked.map((acc: IProductAccessoryPayment, accIndex: number) => (
                                                <div key={`${index}_${accIndex}`} className={"flex justify-between " + isFull ? "ml-4" : ""}>
                                                    <div>{acc.name} <sup>x {acc.qty}</sup></div>
                                                    <div className="text-right">{currencyFormatter.format(acc.price ?? 0)}</div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                )
                            }



                            return (
                                <>
                                    {item.checked && <div key={index} className="flex justify-between">
                                        <div>{item.name} <sup>x {item.qty}</sup></div>
                                        <div className="text-right">{currencyFormatter.format(item.price)}</div>
                                    </div>}
                                    {
                                        accessoriesChecked?.map((acc: any, accIndex: number) => {
                                            if (acc.qty > item.qty) {
                                                return <div key={`${index}_${accIndex}`} className={"flex flex-row justify-between " + (item.checked ? "ml-4" : "")}>
                                                    <div>{acc.name} <sup>x {acc.qty - item.qty}</sup></div>
                                                    <div className="text-right">{currencyFormatter.format(acc.price ?? 0)}</div>
                                                </div>
                                            }
                                            if (acc.bundling_id) {
                                                return <div key={`${index}_${accIndex}`} className={"flex flex-row justify-between " + (item.checked ? "ml-4" : "")}>
                                                    <div>{acc.name} <sup>x {acc.qty}</sup></div>
                                                    <div className="text-right">{currencyFormatter.format(acc.price ?? 0)}</div>
                                                </div>
                                            }
                                            return <>
                                            </>
                                        })
                                    }
                                </>
                            )
                        })
                    }
                </div>


                <div className="box-info p-4 rounded-lg bg-white grid-cols-1 md:col-span-2 relative">
                    {/* <div className="cursor-pointer absolute right-4 top-4" onClick={() => { setModalCustomer({ open: true, type: 'sellCustomer' }) }}>
                        <EditOutlined style={{ color: '#36CFC9' }} rev={undefined} />
                    </div> */}
                    <div>Tên người nhận: {sellCustomer.name}</div>
                    <div>Số điện thoại: {sellCustomer.phone}</div>
                    <div>Email: {sellCustomer.email}</div>
                    <div>
                        <div>Địa chỉ: {sellCustomer.address}, {sellCustomer.ward_name}, {sellCustomer.district_name}, {sellCustomer.province_name}</div>
                    </div>
                    <div>Ghi chú: {sellCustomer.note}</div>
                </div>
            </div>

            <div className="mt-4">
                <div className="box-info p-4 rounded-lg bg-white">
                    <div className="grid grid-cols-1 md:grid-cols-2 items-center">
                        <div className="grid gap-1">
                            <div className="grid grid-cols-2">
                                <div>Tổng: </div>
                                <div className="text-right">{currencyFormatter.format(sellTotal ?? 0)}</div>
                            </div>
                            <div className="grid grid-cols-2">
                                <div>Phí giao hàng: </div>
                                <div className="text-right">{currencyFormatter.format(sellTransportFee ?? 0)}</div>
                            </div>
                        </div>


                        {
                            isMobile ? (
                                <div className="flex justify-between color-danger bold">
                                    <div>Tổng đơn mua:</div>
                                    <div>{currencyFormatter.format((sellTotal ?? 0) + (sellTransportFee ?? 0))}</div>
                                </div>
                            ) : (
                                <div className="text-right color-danger text-2xl bold">
                                    Tổng đơn mua: {currencyFormatter.format((sellTotal ?? 0) + (sellTransportFee ?? 0))}
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        </div>
    ) : null
}

export default SellPayment;
